module.exports = __webpack_public_path__ + "img/sauna_tent_4.c5614600.jpg";